import React from "react";
import { useAdminAutoTradeIbkrPositions } from '_hooks/useAdminAutoTradeIbkrPositions';
import {ReactTableHelper} from "../../../_utils/ReactTableHelper";
import {DataGridTableColumns} from "../common/DataGrid";
import {Spinner} from "../../common/Spinner";
import { IAutoTradeIbkrPosition } from "predictagram-lib";

export const IbkrPositionsList: React.FunctionComponent = () => {
  const { api} = useAdminAutoTradeIbkrPositions();

  const columnHelper = ReactTableHelper.createHelper<IAutoTradeIbkrPosition>();
  const columns = [
    columnHelper.columnBuilder('fullName', {header: 'Name'}).build(),
    columnHelper.columnBuilder('quantity', {header: 'Quantity',}).number().build(),
    columnHelper.columnBuilder('contractId', {header: 'Contract ID',}).number().build(),
    // columnHelper.columnBuilder('close.time', {
    //   header: 'Close EST',
    //   cell: (i)=> DateHelper.dateTimeFormatUs(i.getValue()),
    // }).build(),
    // columnHelper.columnBuilder('profit.amount', {header: 'Profit $'}).number({fixed:4}).build(),
    // columnHelper.columnBuilder('profit.rate', {header: 'Profit %'}).number({fixed:2,percentage:true}).build(),
  ];

  return (<>
    <div className="page-title my-3">IBKR Account's Positions</div>
    {api.state.isLoading() && <Spinner/>}
    {api.state.isError() && <div>{api.state.error()?.message}</div>}
    {api.state.isLoaded() && <>
      <DataGridTableColumns columns={columns} data={api.data || []} sorting={false}/>
    </>}

    <div className="my-3 mb-5">
      <hr />
      <p className="fw-bold">NOTES:</p>
      Data is queried directly from IBKR Account. If there is a position with not zero quantity, most likely it means the position really exists if login to IBKR account. The list should be usually empty when stock marked is closed.
    </div>
  </>)
}
